import { MunicipalPropertyHistoryQuery } from "@/graphql/generated/graphql";

import { MunicipalPropertyStand } from "./municipal-property-stand.model";

export function toMunicipalPropertyStand(
  historyData: MunicipalPropertyHistoryQuery["municipalPropertyHistory"] | undefined,
): MunicipalPropertyStand | null {
  if (
    !historyData?.property ||
    typeof historyData.effectiveYear !== "number" ||
    typeof historyData.standUpdatedAt !== "string" ||
    !historyData.standUpdatedAt
  )
    return null;
  return {
    property: historyData.property,
    effectiveYear: historyData.effectiveYear,
    effectiveYearList: historyData.effectiveYearList,
    standUpdatedAt: historyData.standUpdatedAt,
  };
}
